import React from 'react';
import { getConfig } from '../../../../utils/config';

function Search({ searchInput, setSearchInput, currentPage, setCurrentPage }) {
    const config = getConfig();
    let search = [];
    const onChangeHandler = (e) => {
        if (currentPage != 1) {
            setCurrentPage(1);
        }
        setSearchInput(String(e.target.value));
    };

    return (
        <div
            className={
                ` ${config?.blogs?.detailsPageBackgroundColor}` +
                ' mt-5 border p-4'
            }
        >
            <div className=" h-8 w-full flex ">
                <p
                    className={
                        `${config?.blogs.sideBarClass} ` +
                        'self-center font-semibold px-2'
                    }
                >
                    SEARCH
                </p>
            </div>
            <div class="flex items-center justify-center from-cyan-100 via-pink-200 to-yellow-200 bg-gradient-to-br mt-2">
                <div class="flex items-center w-full  ">
                    <div class="w-full">
                        <input
                            type="search"
                            className={
                                ' w-full px-4 py-1 bg-transparent text-gray-800 border h-10  focus:outline-none'
                            }
                            placeholder="Search here"
                            value={searchInput}
                            onChange={(e) => onChangeHandler(e)}
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            class={`flex items-center bg-blue-500 justify-center w-10 h-10 p-1 text-white 
                ${
                    search.length > 0
                        ? 'bg-purple-500'
                        : 'bg-gray-500 cursor-not-allowed'
                }`}
                            disabled={search.length == 0}
                        >
                            <svg
                                class="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Search;
